import { render, staticRenderFns } from "./_base-form-item-read-only.vue?vue&type=template&id=98b09d40&scoped=true&"
import script from "./_base-form-item-read-only.vue?vue&type=script&lang=js&"
export * from "./_base-form-item-read-only.vue?vue&type=script&lang=js&"
import style0 from "./_base-form-item-read-only.vue?vue&type=style&index=0&id=98b09d40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b09d40",
  null
  
)

export default component.exports